import { render } from "./NewsVersionView.vue?vue&type=template&id=39f5c418&scoped=true"
import script from "./NewsVersionView.vue?vue&type=script&lang=js"
export * from "./NewsVersionView.vue?vue&type=script&lang=js"

import "./NewsVersionView.vue?vue&type=style&index=0&id=39f5c418&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f5c418"]])

export default __exports__